module.exports = __webpack_public_path__ + "img/FZLC_7.24382cae.jpg";